<template lang="pug">
#pencil
  //- 画笔清除图标
  van-image.penclestyle(@click='cleanPencil' width='55' height='55' :src='pencilClear' v-if='pencilBoolean')
  .pencilepop(v-if='pencilBoolean')
    ul
      li(v-for='(item,index) in pencilList' :key='index' @click='openPencilPanel(item,index)')
        van-image(width='20' height='20' :src='item.icon' v-if="item.query !== 'control'||!item.isActive")
        van-image(width='20' height='20' :src='item.icons' v-else)
        span {{item.name}}
    span.line
  //- 画笔
  .setpencils(v-show='pencilDetailBoolean')
    .pencilSize
      span.name(v-if="pencilType !=='TEXT' && pencilType !=='LEAD_LINE'") 笔触
      span.name(v-else='') 字号
      ul
        li(@click="setPencilSize('big',0)")
          span.circle.big(:style="{'background': isActive === 0? colorData : '#fff'}")
          span 大
        li(@click="setPencilSize('middle',1)")
          span.circle.middle(:style="{'background': isActive === 1? colorData : '#fff'}")
          span 中
        li(@click="setPencilSize('small',2)")
          span.circle.small(:style="{'background': isActive===2? colorData : '#fff'}")
          span 小
      .detailColse
        van-icon.dePencilIcon(name='delete-o' size='22' v-if='!!editId' @click='delPencilLine')
        van-icon.dePencilIcon(name='close' size='22' @click='dePencilFuncEdit')
    .pencilColor
      span.name 颜色
      van-radio-group(v-model='colorData' @change='changeColor')
        van-radio(name='#ff4500' shape='square' checked-color='#ff4500' style='background: #ff4500')
        van-radio(name='#ff8c00' shape='square' checked-color='#ff8c00' style='background: #ff8c00')
        van-radio(name='#ffd700' shape='square' checked-color='#ffd700' style='background: #ffd700')
        van-radio(name='#45e745' shape='square' checked-color='#45e745' style='background: #45e745')
        van-radio(name='#1e90ff' shape='square' checked-color='#1e90ff' style='background: #1e90ff')
  //-文字弹框
  van-popup.intext(v-model='pencilTextPopup')
    .despop
      van-field(v-model='inputTextVal' type='textarea' placeholder='请输入文字' :autofocus='true' ref='inputtexta')
    .btnpop
      van-button(plain type='info' size='mini' @click='pencilTextPopup = false') 取消
      van-button(type='primary' size='mini' @click='textFunc') 确认
  //-清除画笔提示
  van-popup.dialogpop(v-model='cleanPencilPopup')
    .desContent
      | 画笔清空后，将无法恢复，
      br
      |  确认清空吗？
    .btnpop
      van-button(plain='' type='info' size='small' @click='cleanPencilPopup = false') 取消
      van-button(type='primary' size='small' @click='cleanAllpencil') 确认
  </template>

<script>
import mongeApiMlib from "@/CommonDP/mongeView/mongeApiMlib";
export default {
  data () {
    return {
      pencilList: [
        { name: "直线", icon: require("@/CommonDP/mongeView/appView/images/line.png"), query: "LINE" },
        { name: "手绘线", icon: require("@/CommonDP/mongeView/appView/images/anyway.png"), query: "PENCIL" },
        { name: "云线", icon: require("@/CommonDP/mongeView/appView/images/cloudline.png"), query: "RECT_CLOUD" },
        { name: "文字", icon: require("@/CommonDP/mongeView/appView/images/text.png"), query: "TEXT" },
        { name: "引线", icon: require("@/CommonDP/mongeView/appView/images/leadline.png"), query: "LEAD_LINE" },
        { name: "箭头", icon: require("@/CommonDP/mongeView/appView/images/arrow.png"), query: "ARROW" },
        { name: "矩形", icon: require("@/CommonDP/mongeView/appView/images/rect.png"), query: "RECT" },
        { name: "椭圆", icon: require("@/CommonDP/mongeView/appView/images/ellipse.png"), query: "ELLIPSE" },
        { name: "隐藏", icon: require("@/CommonDP/mongeView/appView/images/hideeye.png"),
          icons: require("@/CommonDP/mongeView/appView/images/showeye.png"), query: "control", isActive: false }
      ],
      pencilClear: require("@/CommonDP/mongeView/appView/images/pencilClear.png"),
      pencilBoolean: true,
      pencilDetailBoolean: false,
      isActive: 1,
      activeColor: '',
      colorData: "#ff4500",
      pencilType: '',
      pencilTextPopup: false,
      cleanPencilPopup: false,
      inputTextVal: '',
      editId: ''// 选中的画笔工具
    };
  },
  methods: {
    openPencilPanel(item, index) {
      if (item.query === "control") {
        this.pencilList.forEach(ele => {
          if (ele.query === "control") {
            ele.isActive = !ele.isActive;
            if (ele.isActive) {
              mongeApiMlib.hiddenPencilAll();
            } else {
              mongeApiMlib.showPencilAll();
            }
          }
        });
      } else {
        this.editId = "";
        this.pencilDetailBoolean = true;
        this.pencilType = item.query;
        this.addPencil();
      }
    },
    // 清除画笔 按钮
    cleanPencil() {
      this.cleanPencilPopup = true;
    },
    async setPencilSize(type, index) {
      this.isActive = index;
      if (this.editId) {
        let fontSize, lineWidth;
        if (this.pencilType === "TEXT") {
          fontSize = this.selectSize(false);
          await mongeApiMlib.pencilSetFontSize(this.editId, fontSize);
        } else if (this.pencilType === "LEAD_LINE") {
          fontSize = this.selectSize(false);
          lineWidth = this.selectSize(true);
          await mongeApiMlib.pencilSetFontSize(this.editId, fontSize);
          await mongeApiMlib.pencilSetLineWidth(this.editId, lineWidth);
        } else {
          lineWidth = this.selectSize(true);
          await mongeApiMlib.pencilSetLineWidth(this.editId, lineWidth);
        }
      } else {
        this.addPencil();
      }
    },
    changeColor() {
      if (this.editId) {
        const color = this.colorData ? "0x" + this.colorData.substr(1) : "0xFFFFFF";
        mongeApiMlib.pencilSetColor(this.editId, color);
      } else {
        this.addPencil();
      }
    },
    async addPencil() {
      const color = this.colorData ? "0x" + this.colorData.substr(1) : "0xFFFFFF";
      let fontSize, lineWidth;
      if (this.pencilType === "TEXT") {
        fontSize = this.selectSize(false);
      } else if (this.pencilType === "LEAD_LINE") {
        fontSize = this.selectSize(false);
        lineWidth = this.selectSize(true);
      } else {
        lineWidth = this.selectSize(true);
      }
      await mongeApiMlib.pencilH52D(this.pencilType, color, lineWidth, fontSize, {
        callback: async (type, data) => {
          // if (type === Monge.CallbackType.DONE) {
          //   debugger;
          // } else
          if (type === Monge.CallbackType.SELECT) {
            if (data?.id) {
              this.editId = data.id || '';
              this.dealpencilType(data.type);
              this.pencilDetailBoolean = true;
            }
          } else if (type === Monge.CallbackType.INPUT) {
            this.pencilTextPopup = true;
            await this.$nextTick();
            this.$refs.inputtexta.focus();
          }
        }
      });
    },
    // 字体弹框确认
    textFunc() {
      mongeApiMlib.pencilSetText(this.inputTextVal);
      this.inputTextVal = "";
      this.pencilTextPopup = false;
    },
    // 清空画笔确认按钮
    cleanAllpencil() {
      mongeApiMlib.clearPencil();
      this.cleanPencilPopup = false;
    },
    // 删除点击的画笔
    async delPencilLine() {
      await mongeApiMlib.pencilRemoveById(this.editId);
      this.editId = "";
      this.pencilDetailBoolean = false;
    },
    // 关闭编辑笔触弹框
    dePencilFuncEdit() {
      mongeApiMlib.pencilDeactive();
      this.pencilDetailBoolean = false;
    },
    selectSize(isline) {
      let dataSize;
      switch (this.isActive) {
        case 0:
          dataSize = isline ? "5" : "40";
          break;
        case 1:
          dataSize = isline ? "3" : "30";
          break;
        case 2:
          dataSize = isline ? "1" : "20";
          break;
      }
      return dataSize;
    },
    dealpencilType(type) {
      switch (type) {
        case 8:
          this.pencilType = "LINE";
          break;
        case 1:
          this.pencilType = "PENCIL";
          break;
        case 7:
          this.pencilType = "RECT_CLOUD";
          break;
        case 4:
          this.pencilType = "TEXT";
          break;
        case 5:
          this.pencilType = "LEAD_LINE";
          break;
        case 2:
          this.pencilType = "ARROW";
          break;
        case 3:
          this.pencilType = "RECT";
          break;
        case 6:
          this.pencilType = "ELLIPSE";
          break;
        default:
          break;
      }
    }

  }
};
</script>

  <style lang="scss" scoped>
  .penclestyle{
    position: absolute;
    right: 20px;
    bottom: 120px;
  }
  .pencilepop{
    position: absolute;
    width: calc(100% - 24px);
    height: 60px;
    background: rgba(0, 0, 0, 0.68);
    bottom: 58px;
    margin-left: 12px;
    border-radius: 5px;
    overflow: hidden;
    .line{
      width: 2px;
      height: calc(100% - 30px);
      display: inline-block;
      position: absolute;
      right: 0;
      background: #1278FF;
      top: 15px;
    }
    ul{
      width: 100%;
      height: 100%;
      overflow-y: hidden;
      overflow-x: auto;
      display: inline;
      float: left;
      white-space: nowrap;
      -webkit-overflow-scrolling: touch; /*解决在ios滑动不顺畅问题*/
    }
    ul::-webkit-scrollbar {
      display: none;
    }

    li{
      display: inline-block;/*设置li为行内块级元素*/
      list-style: none;
      width: 60px;
      height: 100%;
      font-size: 12px;
      color: #dddddd;
      padding-top: 10px;
      .van-image{
        display: block;
        margin: auto;
      }
      span{
        text-align: center;
        display: block;
        margin-top: 5px;
      }
    }
  }

  .setpencils{
    position: absolute;
    bottom: 58px;
    width: calc(100% - 24px);
    height: 120px;
    margin-left: 12px;
    background: rgba(26, 36, 48, 1);
    color: #ffffff;
    font-size: 14px;
    padding: 0 10px;
    z-index: 10;

    .pencilSize,.pencilColor{
      width: 100%;
      height: 50%;
      box-sizing: border-box;
      display: flex;
      flex-direction: row;
      align-items: center;
      .detailColse{
        margin-left: auto;
        display: flex;
        flex-direction: row;
        align-items: center;
        .van-icon{
          margin-right: 10px;
        }
      }
      .name{
        color: #EBEBEB;
        font-size: 15px;
        margin-right: 20px;
      }
      ul{
        display: flex;
        flex-direction: row;
        align-items: center;
        li{
          width: 45px;
          display: flex;
          flex-direction: row;
          align-items: center;
          margin-right: 20px;
        }
        .circle{
          background-color: #fff;
          margin-right: 6px;
        }
        .big{
          width: 18px;
          height: 18px;
          border-radius: 9px;
        }
        .middle{
          width: 16px;
          height: 16px;
          border-radius: 8px;
        }
        .small{
          width: 12px;
          height: 12px;
          border-radius: 6px;
        }
      }
    }
    .pencilSize{
      border-bottom: 1px solid rgba(229, 232, 241, 0.11);;
    }
    .van-radio-group{
      display: flex;
      flex-direction: row;
      align-items: center;
      .van-radio{
        margin-right: 10px;
        border-radius: 4px;
        border: 0;
      }
    }
  }

  .intext{
    width: calc(100% - 24px);
    height: 222px;
    border-radius: 5px;
    background: rgba(26, 36, 48, 0.9);

    .despop {
      padding: 15px;
      text-align: center;

      .van-cell {
        min-height: 134px !important;
        background: rgba(0, 0, 0, 0.56);
        border-radius: 10px;
        border: 0;

        /deep/.van-field__body {
          height: 100% !important;
        }

        /deep/.van-field__control {
          height: 100%;
          color: #FFFFFF;
          text-align: left;
          font-size: 15px;
          padding: 10px 0 0 10px;
        }
      }
    }

    .btnpop {
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 44px;
      padding-top: 5px;

      .van-button {
        width: 35%;
        height: 34px;
        line-height: 34px;
        font-size: 18px;
        border-radius: 60px;
        background: none;
        border: 0;
      }

      /deep/ .van-button--plain.van-button--info {
        color: #FFFFFF;
        border: 1px solid #fff;
      }

      /deep/ .van-button--primary {
        background: var(--theme-color);
        border: 0;
        box-shadow: 0px 0px 20px rgba(51, 114, 255, 0.54);
      }
    }
  }

  .dialogpop{
    width: calc(100% - 24px);
    height: 160px;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #FFF;
    .desContent{
      height: 80px;
      font-size: 16px;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .btnpop {
      display: flex;
      justify-content: space-around;
      width: 100%;
      height: 44px;
      overflow: hidden;
    }
    .btnpop .van-button {
      width: 40%;
      height: 100%;
      font-size: 28px;
      border-radius: 30px;
      color: #FFFFFF;
    }
    .van-button--info{
      background: #FFFFFF;
      border: 1px solid #D8D8D8;
      .van-button__text{
        color:var(--theme-color);
        font-size: 16px;
      }
    }
    .van-button--primary{
      background: var(--theme-color);
      border: 0;
      .van-button__text{
        color: #FFFFFF;
        font-size: 16px;
      }
    }
  }

  </style>
